import { useTheme } from 'foundations-theming-specialty/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const ArrowDownIcon = ({
  className
}) => {
  const theme = useTheme();
  return /*#__PURE__*/_jsx("svg", {
    fill: theme.color['global-shell-icon-nav-item-default'],
    width: "10px",
    height: "10px",
    viewBox: "0 0 24 13",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    className: className,
    children: /*#__PURE__*/_jsx("path", {
      d: "m21.47 0.41l-9.47 9.02-9.47-9a1.5 1.5 0 1 0 -2.06 2.16l10.5 10a1.51 1.51 0 0 0 0.44 0.28 1.43 1.43 0 0 0 1 0 1.52 1.52 0 0 0 0.59 -0.26l10.5-10a1.5 1.5 0 1 0 -2.03 -2.2"
    })
  });
};
export default ArrowDownIcon;